import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      const { data } = event || {}
      const { id, name } = data || {}

      // do not show company edit view if id is invalid
      if (!id) {
        return
      }

      // used as breadcrumb value
      const query = {
        company: name || DEFAULT_EMPTY_VALUE
      }

      this.$router.push({
        name: 'Company',
        params: {
          id
        },
        query
      }).then()
    },

    onCompanyActivation (event) {
      const { deactivated_at: deactivatedAt, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('base/company.deactivate') : this.$t('base/company.activate')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('base/company.confirm_deactivation') : this.$t('base/company.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.handleCompanyActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async handleCompanyActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.[this.mainTableKey] || {}
        await api('base').patch(`companies/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onCompanyDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('base/company.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('base/company.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.handleCompanyDeletion(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async handleCompanyDeletion (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.[this.mainTableKey] || {}

        await api('base').delete(`companies/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
